import { HubConnectionBuilder, LogLevel, HttpTransportType } from '@microsoft/signalr'

export default {
    install(Vue) {

        // use new Vue instance as an event bus
        const eventHub = new Vue()
        // every component will use this.$eventHub to access the event bus
        Vue.prototype.$eventHub = eventHub

        let connection = null
        let startedPromise = null
        let manuallyClosed = false
        //, jwtToken ? { accessTokenFactory: () => jwtToken } : null
        Vue.prototype.startSignalR = (jwtToken) =>  {

            connection = new HubConnectionBuilder()
                .configureLogging(LogLevel.Information)
                .withUrl('/eventhub', { transport: HttpTransportType.WebSockets | HttpTransportType.LongPolling })
                .build();

            // Forward server side SignalR events through $eventHub, where components will listen to them
            connection.on('NotifyOrderUpdated', () => {
                eventHub.$emit('order-updated')
            });

            connection.on('InterfaceStatus', (name, isOk) => {
                eventHub.$emit('interface-status', name, isOk)
            });

            // You need to call connection.start() to establish the connection but the client wont handle reconnecting for you!
            // Docs recommend listening onclose and handling it there.
            // This is the simplest of the strategies
            function start() {
                startedPromise = connection.start()
                    .catch(err => {
                        console.error('Failed to connect with hub', err)
                        return new Promise((resolve, reject) => setTimeout(() => start().then(resolve).catch(reject), 5000))
                    })
                return startedPromise
            }
            connection.onclose(() => {
                if (!manuallyClosed) start()
            })

            // Start everything
            manuallyClosed = false
            start()
        }
        Vue.prototype.stopSignalR = () => {
            if (!startedPromise) return

            manuallyClosed = true
            return startedPromise
                .then(() => connection.stop())
                .then(() => { startedPromise = null })
        }


    }
}